'use client';

import ProfileCard from './ProfileCard';
import SoloProfileCard from './SoloProfileCard';
import TripletProfileCard from './TripletProfileCard';
import ProfileCardDemo from './ProfileCardDemo';
import EmailLayoutDemo from './EmailLayoutDemo';
import MetadataSparseVsCondensed from './MetadataSparseVsCondensed';
import FitContentDemo from './FitContentDemo';
import BigHelloWorld from './BigHelloWorld';
import RecursiveNightmare from './RecursiveNightmare';
import ContainmentDemo from './ContainmentDemo';

const MAP = {
  ProfileCard,
  SoloProfileCard,
  TripletProfileCard,
  ProfileCardDemo,
  EmailLayoutDemo,
  MetadataSparseVsCondensed,
  FitContentDemo,
  BigHelloWorld,
  RecursiveNightmare,
  ContainmentDemo,
};

type Variant = keyof typeof MAP;

export default function ContainerQueriesDemo({
  variant,
  ...props
}: {
  variant: Variant;
}) {
  const Component = MAP[variant];

  // There's probably a proper way to do this, so that TypeScript validates the props passed to all valid children, but it seems complicated
  // @ts-ignore
  return <Component {...props} />;
}
